<template>
  <div class="teachers-form-container">
    <div class="container">
      <div class="row">
        <teacher-information
          :teacher="teacher"
          :grades="grades"
          :centers="centers"
          :states="states"
          :zip-codes="zipCodes"
          :filled-steps="filledSteps"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TeacherInformation from './Forms/TeacherInformation.vue'

export default {
  name: 'TeachersForm',
  props: {
    teacher: Object,
    grades: Array,
    centers: Array,
    zipCodes: Array,
    states: Array,
    filledSteps: Array
  },
  components: {
    TeacherInformation
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/TeachersForm/Index.vue